import type { ReactNode } from 'react'

import { Typography } from '@twisto/components/atoms/typography'

import { useList } from '../list.context'

import * as styles from './base-list-item.styles'

type Props = {
  hasGap: boolean
  icon: ReactNode
  children: ReactNode
}

export const BaseListItem = ({ hasGap, icon, children, ...rest }: Props) => {
  const { variant } = useList()

  return (
    <li
      css={[styles.root, hasGap && styles.gap]}
      data-testid="base-list-item"
      {...rest}
    >
      <span aria-hidden="true" css={styles.iconWrapper[variant]}>
        {icon}
      </span>
      <Typography
        color="textSecondary"
        variant={variant === 'medium' ? 'b2' : 'b3'}
      >
        {children}
      </Typography>
    </li>
  )
}
